
// TODO 订单支付完成页

export default [
  {
    path: '/master/info',
    name: 'orderResult',
    component: () => import(/* webpackChunkName: "orderResult" */ '@/views/master/info.vue')
  }
]
